import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
    providedIn: 'root',
})
export class HomePageHttpService {
    constructor(private configurations: ConfigurationService, private http: HttpClient) {}

    getHomePage(): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/homepage/getHomePage`);
    }

    updateHomePage(homePage: any): Observable<any> {
        return this.http.put<any>(`${this.configurations.baseUrl}/api/homepage/updateHomePage`, homePage);
    }
}
